import apisaucePlugin from 'reactotron-apisauce'
import Reactotron from 'reactotron-react-js'
import { reactotronRedux } from 'reactotron-redux'
import sagaPlugin from 'reactotron-redux-saga'

const reactotron = Reactotron.configure({ name: 'PeakPro Front' })
    .use(apisaucePlugin())
    .use(reactotronRedux())
    .use(sagaPlugin())
    .connect()

console.tron = reactotron

reactotron.clear()

export default reactotron
